export function getImageUrl(guid, type, platformSlug, w = 1200, h = 630) {
  return `https://scontent.ccdn.cloud/${type}/${platformSlug}/${guid}/${w}x${h}.jpg`
}
export function getFluidImageUrl(guid, type, platformSlug, w = 1200) {
  return `https://scontent.ccdn.cloud/${type}/${platformSlug}/${guid}/maxw-${w}.jpg`
}
export function getPostUrl(slug) {
  return `/${slug}/`
}
export function getCategoryUrl(slug, page) {
  return `/${slug}${page > 1 ? `/${page}/` : `/`}`
}
